(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keepp-base"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.documentElement.classList.add('kp-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function run(){
    var els = document.querySelectorAll('.kp .reveal');
    if (reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) { els.forEach(function(e){e.classList.add('in');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    els.forEach(function(e){ io.observe(e); });
  }
  function wireToggles(){
    document.querySelectorAll('.kp .tabbtn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var scope = btn.closest('.kp');
        scope.querySelectorAll('.tabbtn').forEach(function(b){ b.classList.remove('act'); b.setAttribute('aria-selected','false'); });
        scope.querySelectorAll('.panel').forEach(function(p){ p.classList.remove('act'); });
        btn.classList.add('act'); btn.setAttribute('aria-selected','true');
        var t = scope.querySelector('#'+btn.getAttribute('data-tab')); if(t) t.classList.add('act');
      });
    });
    document.querySelectorAll('.kp .ctog').forEach(function(btn){
      btn.addEventListener('click', function(){
        var scope = btn.closest('.kp');
        scope.querySelectorAll('.ctog').forEach(function(b){ b.classList.remove('act'); b.setAttribute('aria-selected','false'); });
        scope.querySelectorAll('.cview').forEach(function(v){ v.classList.remove('act'); });
        btn.classList.add('act'); btn.setAttribute('aria-selected','true');
        var v = scope.querySelector('#'+btn.getAttribute('data-view')); if(v) v.classList.add('act');
      });
    });
    document.querySelectorAll('.kp .opt').forEach(function(o){
      o.addEventListener('click', function(){
        var box = o.closest('.buy') || o.closest('.kp');
        box.querySelectorAll('.opt').forEach(function(x){ x.classList.remove('sel'); });
        o.classList.add('sel');
      });
    });
  }
  function animateCounts(){
    if (reduce || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('.kp [data-count]').forEach(function(el){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(!e.isIntersecting) return;
          var target = parseFloat(el.getAttribute('data-count')), dur = 1200, start = null;
          function tick(ts){ if(!start) start = ts; var p = Math.min((ts-start)/dur, 1);
            el.textContent = Math.round(target*p).toLocaleString();
            if(p<1) requestAnimationFrame(tick); else el.textContent = target.toLocaleString();
          }
          requestAnimationFrame(tick); io.unobserve(el);
        });
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }
  function animateCharts(){
    if (reduce || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('.kp .chartcard svg').forEach(function(svg){
      var lines = svg.querySelectorAll('.l-water,.l-form');
      lines.forEach(function(ln){ try{ var len = ln.getTotalLength(); ln.style.strokeDasharray = len; ln.style.strokeDashoffset = len; }catch(err){} });
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(!e.isIntersecting) return;
          lines.forEach(function(ln,i){ ln.style.transition = 'stroke-dashoffset 1.3s ease ' + (i*0.25) + 's'; ln.style.strokeDashoffset = '0'; });
          io.unobserve(svg);
        });
      }, { threshold: 0.3 });
      io.observe(svg);
    });
  }
  function initAll(){ run(); wireToggles(); animateCounts(); animateCharts(); }
  if (document.readyState !== 'loading') { initAll(); } else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
